import { postRequest } from "../config/AxiosConfig";
import API_URLS from "../config/BackendConfig";
import { getAuthToken } from "../utils/tokenUtils";

export const RetriveServicecategoryService = () => {
  try {
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "retrive/service-category",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {}
};

export const CreateServiceCategoryService = ({ serviceName }) => {
  try {
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "create/service-category",
      data: { name: serviceName },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {}
};

export const RetriveServiceReportService = (page = 1, total_data = 100) => {
  try {
    const token = getAuthToken();

    return postRequest({
      url: `${API_URLS.ADMIN}service/report?page=${page}`,
      data: { total_data },
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error("Error:", error);
  }
};

export const RetriveServiceReportService2 = (total_data) => {
  try {
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "service/report",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: total_data,
    });

    return response;
  } catch (error) {
    console.error("Error in RetriveServiceReportService:", error);
    throw error;
  }
};

export const RetriveServiceReportService3 = (total_data) => {
  try {
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "vendor/service-list",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: total_data,
    });

    return response;
  } catch (error) {
    console.error("Error in RetriveServiceReportService:", error);
    throw error;
  }
};

export const RetriveActiveServiceReportService = async ({ page }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + `service/assigned/report?page=${page}`,
      headers: { Authorization: `Bearer ${token}`, data: { total_data: 14 } },
    });
    return response;
  } catch (error) {}
};
export const RetriveServiceEditService = ({ serviceId }) => {
  try {
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "service/edit",
      data: { service_id: serviceId },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {}
};

export const addApiService = async ({
  categoryId,
  serviceName,
  postUrl,
  introduction,
  requestResponse,
  failedResponse,
  fees,
  adjustment_type,
  successResponse,
  system_name,
  preference,
  status_id,
  vendor_id,
  key_description,
  service_value,
  method,
  per_hit_cost,
  skip_status_codes,
}) => {
  try {
    const payload = {
      skip_status_codes: skip_status_codes ? `${skip_status_codes}` : "500",
      service_category_id: categoryId,
      service_name: serviceName,
      end_point: postUrl,
      introduction: introduction,
      request: requestResponse,
      failed_response: failedResponse,
      activation_fee: fees,
      agreement_required: true,
      adjustment_type: adjustment_type,
      response: successResponse,
      system_name: system_name,
      preference: preference,
      status_id: status_id,
      vendor_id: vendor_id,
      key_description: key_description,
      service_value: service_value,
      method: method,
      per_hit_cost: per_hit_cost,
    };
    console.log(payload);
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "create/service",
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {}
};

export const updateApiService = async ({
  skip_status_codes,
  serviceId,
  categoryId,
  serviceName,
  postUrl,
  introduction,
  requestResponse,
  failedResponse,
  fees,
  adjustment_type,
  successResponse,
  system_name,
  preference,
  statusAdd,
  vendorId,
  keyDescription,
  serviceValue,
  method,
  per_hit_cost,
}) => {
  try {
    const payload = {
      skip_status_codes: skip_status_codes ? `${skip_status_codes}` : "500",
      service_id: serviceId,
      service_category_id: categoryId,
      service_name: serviceName,
      end_point: postUrl,
      introduction: introduction,
      request: requestResponse,
      failed_response: failedResponse,
      activation_fee: fees,
      agreement_required: true,
      adjustment_type: adjustment_type,
      response: successResponse,
      system_name: system_name,
      preference: preference,
      status_id: statusAdd,
      key_description: keyDescription,
      service_value: serviceValue,
      method: method,
      per_hit_cost: per_hit_cost,
    };

    // 🔥 Key logic:
    // If vendorId has value => send it
    // If vendorId is null => DO NOT send vendor_id
    if (vendorId !== null && vendorId !== undefined) {
      payload.vendor_id = vendorId;
    }

    const token = getAuthToken();

    const response = postRequest({
      url: API_URLS.ADMIN + "service/update",
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    });

    return response;
  } catch (error) {
    return error;
  }
};

export const fetchVendorForAddingService = async (total_data = 100) => {
  try {
    const token = getAuthToken();

    const response = await postRequest({
      url: `${API_URLS.ADMIN}vendor/list`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { total_data },
    });

    return response;
  } catch (error) {
    console.error("Error fetching vendor list:", error);
    throw error;
  }
};

export const asignService = async ({ formData }) => {
  try {
    const payload = {
      service_id: formData.serviceId,
      user_id: formData.userId,
      package_id: formData.packageId,
      remarks: formData.remarks,
      domain: formData.postUrl,
      sales_employee_id: formData.staffId,
      scope: formData.scope,
      pay_account_status: formData.pay_account_status,
      daily_limit: formData.daily_limit,
      monthly_limit: formData.monthly_limit,
      service_status: formData.status,
      environment: formData.environment,
      request_count: formData.request_count,
      login_id: formData.login_id,
      password: formData.password,
      merchant_code: formData.merchant_code,
      scheme_code: formData.scheme_code,
      encryption_key: formData.encryption_key,
      encryption_iv: formData.encryption_iv,
      salt: formData.salt,
      status: formData.status,

      //  NEW RESTRICTION FIELDS
      restriction_type: formData.restriction_type || "none",
      ips: formData.ips || [],
      domains: formData.domains || [],
    };
    // console.log(formData)
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "service/assign",
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const toggleService = ({ selectedId, statusId }) => {
  try {
    const payload = {
      service_id: selectedId,
      status_id: statusId,
    };

    const token = getAuthToken();
    const response = postRequest({
      // url: API_URLS.ADMIN + "service/toggle-status",
      url: API_URLS.ADMIN + "service/update-status",
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const updateAssignedReportStatus = ({
  userId,
  assignMentId,
  statusType,
}) => {
  try {
    const payload = {
      user_id: userId,
      assignment_id: assignMentId,
      status: statusType,
    };

    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "service/assigned/report",
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};
